import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import { CopyBlock, dracula } from "react-code-blocks";



const PhpLesson11 = () => {
    const [language, changeLanguage] = useState("php");
    const [lineNumbers, toggleLineNumbers] = useState(false);
      const code = (
        'text',
        `
        <?php
          for($i = 1; $i < 10; $i++) {
            //code to be executed
          }
        ?>

        `
      );
      const code1 = (
        'text',
        `
        <?php
         $i = 1;
         while($i < 10) {
            $i++;
         }
        ?>

        `
      );


      const code2 = (
        'text',
        `
        <?php
         $i = 1;
          do{
            //code to be executed
            $i++;
          }while($i < 10);

        ?>

        `
      );

      const code3 = (
        'text',
        `
        <?php
        $array = array(1,2,3,4,5);
        foreach($array as $value){
            // code to be executed
        }

        ?>

        `
      );


      const code4 = (
        'text',
        `
        <?php
         for($i = 1; $i < 10; $i++) {
            echo $i. "\\n";
         }

        ?>

        `
      );


  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">


    <div className="alert alert-secondary" role="alert">
    <h3><strong>Loops</strong></h3>
    <p>Loops in PHP work in the same way as they do in other programming languages. There are several types of loops available in PHP, including:</p>
    <p>1. <b>For loops</b>: Used to repeat a block of code a specific number of times.</p>
    <CopyBlock
    language={"php"}
    text={code}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    <br />
    <p>2. <b>While loops</b>: Used to repeat a block of code as long as a certain condition is true.</p>
    <CopyBlock
    language={"php"}
    text={code1}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    <br />
    <p>3. <b>Do-while loops:</b> Used to repeat a block of code at least once, and then continue repeating the block as long as a certain condition is true.</p>
    <CopyBlock
    language={"php"}
    text={code2}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    <br />
    <p>4. <b>Foreach loops:</b> iterates over elements of an array or object.</p>
    <CopyBlock
      language={"php"}
      text={code3}
      showLineNumbers={lineNumbers}
      theme={dracula}
      wrapLines={true}
      codeBlock
    />
    <p>Here is a for loop that counts from 1 to 10:</p>
    <CopyBlock
    language={"php"}
    text={code4}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    <br />
    <p>This loop will print the numbers 1 - 10. The initialization sets the value of
    <b>`$i`</b> to 1, the condition is <b>`$i &lt;== 10`</b>, and the increment statement <b>`$i++`</b> increases the value of <b>`$i`</b> by 1 after each iteration of the loop.</p>
    </div>




    </div>
    </div>
    </div>
    </HTMLCourseNavProvider>
  )
}
export default PhpLesson11
